import { useEffect, useState } from "react";
import {
  useMediaQuery,
  Box,
  TextField,
  MenuItem,
  Tooltip,
} from "@mui/material";
// import { State, City } from "country-state-city";
import PartnerTransactionTable from "./PartnerTransactionTable";
import { useDispatch, useSelector } from "react-redux";
import { getCityApi } from "../../app/slices/address/citySlice";
import { getStateApi } from "../../app/slices/address/stateSlice";

export default function PartnerTransactionReportTab() {
  const [activeTab, setActiveTab] = useState("buy");
  const [refinery, setRefinery] = useState("all");
  const [metaltype, setMetal] = useState("all");

  const [partnerFilterType, setPartnerType] = useState("all");
  const [region, setRegion] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [debouncedPinCode, setDebouncedPinCode] = useState("");
  const pinCodeError = pinCode.length > 0 && pinCode.length < 6;

  const states = useSelector((state) => state.state.state.data);
  const cities = useSelector((state) => state.augmontcitySlice.data);

  // console.log("selected===================>>>>", selectedState);
  // console.log("CITIES===================>>>>", cities);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getStateApi());
  }, []);

  useEffect(() => {
    if (selectedState.id) dispatch(getCityApi(selectedState.id));
  }, [selectedState]);

  // const allStates = "IN";
  const citiesForState = [];

  // const citiesForState = selectedState ? cities?.data : [];

  // const allStates = State.getStatesOfCountry("IN");
  // const citiesForState = selectedState
  //   ? City.getCitiesOfState("IN", selectedState)
  //   : [];

  // console.log("citiesForState:::::::::::::::::::::::::::", region);

  const regions = [
    "North",
    "South",
    "East",
    "West",
    "Asgari",
    // "Central",
    // "NorthEast",
  ].map((region) => region.toLowerCase());

  const handlePartnerTypeChange = (e) => {
    setPartnerType(e.target.value);
    setRegion("");
    setSelectedState("");
    setSelectedCity("");
    setPinCode("");
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (pinCode.length === 6) {
        setDebouncedPinCode(pinCode);
      } else {
        setDebouncedPinCode("");
      }
    }, 500); // Debounce delay (ms)

    return () => clearTimeout(timer); // Cleanup
  }, [pinCode]);

  const isMobile = useMediaQuery("(max-width:600px)");
  return (
    <Box p={0}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap" // ✅ Wrap on small screens
        gap={{ xs: 1, md: 2 }}
        mb={2}
        width="100%"
      >
        {/* Transaction Type */}
        <TextField
          select
          label="Type"
          value={activeTab}
          onChange={(e) => setActiveTab(e.target.value)}
          size="small"
          fullWidth={isMobile}
          sx={{ minWidth: isMobile ? "100%" : 160 }}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="buy">Buy</MenuItem>
          <MenuItem value="sell">Sell</MenuItem>
          <MenuItem value="redeem">Redeem</MenuItem>
        </TextField>

        {/* Refinery */}
        <TextField
          select
          label="Refinery"
          value={refinery}
          onChange={(e) => setRefinery(e.target.value)}
          size="small"
          fullWidth={isMobile}
          sx={{ minWidth: isMobile ? "100%" : 160 }}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="augmont">Augmont</MenuItem>
          <MenuItem value="mmtc">MMTC</MenuItem>
        </TextField>

        {/* Metal Type */}
        <TextField
          select
          label="Metal"
          value={metaltype}
          onChange={(e) => setMetal(e.target.value)}
          size="small"
          fullWidth={isMobile}
          sx={{ minWidth: isMobile ? "100%" : 160 }}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="gold">Gold</MenuItem>
          <MenuItem value="silver">Silver</MenuItem>
        </TextField>

        {/* Partner Type */}
        <TextField
          select
          label="Partner Type"
          value={partnerFilterType}
          onChange={handlePartnerTypeChange}
          size="small"
          fullWidth={isMobile}
          sx={{ minWidth: isMobile ? "100%" : 180 }}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="region">Region</MenuItem>
          <MenuItem value="city">City</MenuItem>
          <MenuItem value="pincode">Pin Code</MenuItem>
        </TextField>

        {/* Region Dropdown — ONLY if partnerType is region */}
        {partnerFilterType === "region" && (
          <TextField
            select
            label="Region"
            size="small"
            value={region}
            onChange={(e) => setRegion(e.target.value)}
            fullWidth={isMobile}
            sx={{ minWidth: isMobile ? "100%" : 160 }}
          >
            <MenuItem value="">Select Region</MenuItem>
            {regions.map((r) => (
              <MenuItem key={r} value={r}>
                {r}
              </MenuItem>
            ))}
          </TextField>
        )}

        {/* State Dropdown — only for city type */}
        {partnerFilterType === "city" && (
          <TextField
            select
            label="State"
            size="small"
            value={selectedState}
            onChange={(e) => {
              setSelectedState(e.target.value);
              setSelectedCity("");
            }}
            fullWidth={isMobile}
            sx={{ minWidth: isMobile ? "100%" : 180 }}
          >
            <MenuItem value="">Select State</MenuItem>
            {states.map((state) => (
              <MenuItem key={state.id} value={state}>
                {state.name}
              </MenuItem>
            ))}
          </TextField>
        )}

        {/* City Dropdown — only for city type */}
        {partnerFilterType === "city" && selectedState && (
          <TextField
            select
            label="City"
            size="small"
            value={selectedCity}
            onChange={(e) => setSelectedCity(e.target.value)}
            fullWidth={isMobile}
            sx={{ minWidth: isMobile ? "100%" : 180 }}
          >
            <MenuItem value="">Select City</MenuItem>
            {cities?.data?.map((city) => (
              <MenuItem key={city.id} value={city.name}>
                {city.name}
              </MenuItem>
            ))}
          </TextField>
        )}

        {/* Pin Code Input */}
        {partnerFilterType === "pincode" && (
          <Tooltip
            title={pinCodeError ? "Please enter a valid 6-digit pin code" : ""}
            placement="top"
            open={pinCodeError}
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: "#4a2a7d",
                  color: "white",
                  fontSize: 12,
                  px: 1.5,
                  py: 1,
                  borderRadius: 1,
                  "& .MuiTooltip-arrow": {
                    color: "#4a2a7d",
                  },
                },
              },
            }}
          >
            <TextField
              label="Pin Code"
              size="small"
              value={pinCode}
              onChange={(e) => setPinCode(e.target.value)}
              error={pinCodeError}
              fullWidth={isMobile}
              sx={{ minWidth: isMobile ? "100%" : 140 }}
            />
          </Tooltip>
        )}
      </Box>

      {/* <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={2}
        mb={2}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <InputLabel>Type</InputLabel>
          <TextField
            select
            value={activeTab}
            onChange={(e) => setActiveTab(e.target.value)}
            size="small"
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="buy">Buy</MenuItem>
            <MenuItem value="sell">Sell</MenuItem>
            <MenuItem value="redeem">Redeem</MenuItem>
          </TextField>
        </Box>

        <Box display="flex" alignItems="center" gap={1}>
          <InputLabel>Refinery</InputLabel>
          <TextField
            select
            value={refinery}
            onChange={(e) => setRefinery(e.target.value)}
            size="small"
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="augmont">Augmont</MenuItem>
            <MenuItem value="mmtc">MMTC</MenuItem>
          </TextField>
        </Box>

        <Box display="flex" alignItems="center" gap={1}>
          <InputLabel>Metal</InputLabel>
          <TextField
            select
            value={metaltype}
            onChange={(e) => setMetal(e.target.value)}
            size="small"
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="gold">Gold</MenuItem>
            <MenuItem value="silver">Silver</MenuItem>
          </TextField>
        </Box>

        <Box display="flex" alignItems="center" gap={1}>
          <InputLabel>Partner Type</InputLabel>
          <TextField
            select
            value={partnerFilterType}
            onChange={handlePartnerTypeChange}
            size="small"
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="region">Region</MenuItem>
            <MenuItem value="city">City</MenuItem>
            <MenuItem value="pincode">Pin Code</MenuItem>
          </TextField>
        </Box>

        {partnerFilterType === "region" && (
          <TextField
            select
            label="Region"
            size="small"
            value={region}
            onChange={(e) => setRegion(e.target.value)}
            sx={{ minWidth: 160 }}
          >
            <MenuItem value="">Select Region</MenuItem>
            {regions.map((r) => (
              <MenuItem key={r} value={r}>
                {r}
              </MenuItem>
            ))}
          </TextField>
        )}

        {partnerFilterType === "city" && (
          <TextField
            select
            label="State"
            size="small"
            value={selectedState}
            onChange={(e) => {
              setSelectedState(e.target.value);
              setSelectedCity("");
            }}
            sx={{ minWidth: 180 }}
          >
            <MenuItem value="">Select State</MenuItem>
            {allStates.map((state) => (
              <MenuItem key={state.isoCode} value={state.isoCode}>
                {state.name}
              </MenuItem>
            ))}
          </TextField>
        )}

        {partnerFilterType === "city" && selectedState && (
          <TextField
            select
            label="City"
            size="small"
            value={selectedCity}
            onChange={(e) => setSelectedCity(e.target.value)}
            sx={{ minWidth: 180 }}
          >
            <MenuItem value="">Select City</MenuItem>
            {citiesForState.map((city) => (
              <MenuItem key={city.name} value={city.name}>
                {city.name}
              </MenuItem>
            ))}
          </TextField>
        )}

        {partnerFilterType === "pincode" && (
          <Tooltip
            title={pinCodeError ? "Please enter a valid 6-digit pin code" : ""}
            placement="top"
            open={pinCodeError}
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: "#4a2a7d",
                  color: "white",
                  fontSize: 12,
                  px: 1.5,
                  py: 1,
                  borderRadius: 1,
                  "& .MuiTooltip-arrow": {
                    color: "#4a2a7d",
                  },
                },
              },
            }}
          >
            <TextField
              label="Pin Code"
              size="small"
              value={pinCode}
              onChange={(e) => setPinCode(e.target.value)}
              sx={{ minWidth: 140 }}
              error={pinCodeError}
            />
          </Tooltip>
        )}
      </Box> */}

      <PartnerTransactionTable
        type={activeTab}
        refinery={refinery}
        metaltype={metaltype}
        partnerFilterType={partnerFilterType}
        region={region}
        state={selectedState}
        city={selectedCity}
        pincode={debouncedPinCode}
      />
    </Box>
  );
}
